import { useCallback, useMemo, useState, type ReactNode } from "react";
import {
  PageHeaderContext,
  type PageHeaderContextValue,
  type PageMeta,
} from "./usePageHeader";

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [meta, setMetaState] = useState<PageMeta>({});

  const setMeta = useCallback((next: PageMeta) => {
    setMetaState(next);
  }, []);

  const clearMeta = useCallback(() => {
    setMetaState({});
  }, []);

  const value = useMemo<PageHeaderContextValue>(
    () => ({ meta, setMeta, clearMeta }),
    [meta, setMeta, clearMeta],
  );

  return (
    <PageHeaderContext.Provider value={value}>
      {children}
    </PageHeaderContext.Provider>
  );
}
